export const apiUrlBase = "https://roopu-whakatau-backend.onrender.com/"; //For live
//export const apiUrlBase = "https://localhost:44389/"; //For testing locally
export const apiUrlPrefix = apiUrlBase + "api/"; //For testing locally